import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

import { TextDocumentTemplateService } from '../../../services/texts/text-document-template.service';

@Component({
  selector: 'app-text-template-search',
  templateUrl: './text-template-search.component.html',
  styleUrls: ['./text-template-search.component.scss'],
})
export class TextTemplateSearchComponent implements OnInit, OnChanges {
  /**
   * Text document template search term
   * @type {string}
   */
  textTemplateSearchTerm: string;

  /**
   * Indicates if include search result item in output
   */
  @Input() include_item: boolean = false;

  /**
   * Text Document Template id for initial selection
   */
  @Input() textDocumentTemplateId: number | undefined;

  /**
   * Indicates if input size should be small based on bootstrap form-control class
   */
  @Input() small_input: boolean = false;

  /**
   * Indicates if search should be allowed
   */
  @Input() editable: boolean = true;

  /**
   * Additional params for autocomplete search
   */
  @Input() params: any = {};

  /**
   * Get placeholder from parent component and overrides the default in HTML
   */
  @Input() placeholder: string;

  /**
   * Output text document template id on contact selection
   * @param {EventEmitter<number> = new EventEmitter(} ) text_document_template_id variable name
   */
  @Output() text_document_template_id: EventEmitter<number> = new EventEmitter();

  /**
   * Indicates if text document template selection is only to be sent as output and not show in the HTML
   */
  @Input() select_only: boolean = false;

  /**
   * Output selected contact item from the search results
   * @param {EventEmitter<any>    = new EventEmitter(} ) contact variable name
   */
  @Output() text_document_template: EventEmitter<any> = new EventEmitter();

  /**
   * Outputs if text document template selection is to be cleared
   * @param {EventEmitter<any>    = new EventEmitter(} ) clearTextTemplate variable name
   */
  @Output() clearTextTemplate: EventEmitter<any> = new EventEmitter();

  /**
   * Constructor
   * @param {TextDocumentTemplateService} private textDocumentTemplateService Service to access text document templates controller for search related actions
   */
  constructor(private textDocumentTemplateService: TextDocumentTemplateService) {}

  // Component lifecycle events

  /**
   * Called on component initialization
   */
  ngOnInit() {}

  /**
   * Called on changes to component variables
   * @param {any} changes Angular object with variables which have changed
   */
  ngOnChanges(changes: any) {
    if (changes.textDocumentTemplateId && changes.textDocumentTemplateId.currentValue && !this.select_only)
      this.textDocumentTemplateService.show(this.textDocumentTemplateId!).then((response_json) => {
        this.textTemplateSearchTerm = response_json.name;
      });
    else if (this.select_only) this.textDocumentTemplateId = undefined;
  }

  // Component methods

  /**
   * Called to clear selected text template and output to parent component
   */
  clearSelectedTextTemplate(): void {
    this.textDocumentTemplateId = undefined;
    this.textDocumentTemplateId = undefined;
    this.clearTextTemplate.emit('clearTextTemplate');
  }

  /**
   * Called when text template search result item is selected
   * @param {any} item Search result item as per AutoComplete format of label and value fields
   */
  textTemplateSearchOnSelect(item: any): void {
    if (this.include_item) this.textDocumentTemplateId = item.id;
    else this.textDocumentTemplateId = item;
    if (this.select_only) {
      let scope = this;
      this.text_document_template.emit(item);
      window.setTimeout(function () {
        scope.textDocumentTemplateId = undefined;
        scope.textTemplateSearchTerm = '';
      }, 100);
    } else if (this.include_item) {
      this.text_document_template.emit(item);
      this.text_document_template_id.emit(Number(item.id));
    } else this.text_document_template_id.emit(Number(item));
  }
}
